module.exports = __webpack_public_path__ + "img/resolve_before_fr-ch.92e7569e.svg";